import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-vertical-form',
    templateUrl: './vertical-form.component.html',
    styleUrls: ['./vertical-form.component.less'],
    standalone: false
})
export class VerticalFormComponent implements OnInit {

  constructor(private formBuilder:FormBuilder, private logger:NGXLogger,
              private service:DataService,private utilityService:UtilityService,
              private dailog:MatDialog,private router:Router,
              private permissionService:PermissionService,private activatedRoute: ActivatedRoute) { }
  verticalForm:FormGroup;
  isEditedData:boolean = false;
  checked:boolean=false;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  showDeactivateToggle:boolean=false;
  showReactivateToggle:boolean=false;
  reactivatePermission:boolean=false;
  deactivatePermission:boolean=false;
  editPermission:boolean=false;
  addPermission: boolean = false;
  disableSubmit:boolean=false;
  status:string;
  viewLog = this.formBuilder.control(false);
  
  ngOnInit(): void {
    this.viewLog.setValue(false);
    this.getAllPermissions();
    this.initializeForm();
    this.fetchParams();
  }

  private fetchParams(){
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        if(+param['id']){
          this.id.setValue(+param['id']);
          this.getVerticalById();
        }
      }
    )
  }

  private initializeForm(){
    this.verticalForm=this.formBuilder.group({
      id:[],
      parentId:[],
      active:[],
      status:[],
      code:[],
      name:[],
      aliases:this.formBuilder.array([])
    });
  }

  getAliases(){
    return this.aliases.value;
  }

  removeAlias(index:number){
    this.aliases.removeAt(index);
  }

  addAlias(event:MatChipInputEvent)
  {
    const value=(event.value || '').trim();
    if(value.length>0 && value.length<=50){
      this.aliases.push(this.utilityService.getAliasForm(null,value));
    }
    if(event.input) {
      event.input.value = '';
    } 
  }

  private openDailog(message?:string){
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });
  
    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            this.router.navigate([APP_ROUTES.VERTICAL_LIST]);
          }
          else{
            this.saveVertical();
          }
        }
    })
  }
  
  public cancel() {
    if(this.verticalForm.dirty){
      this.isEditedData=false;
      this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT);
    }
    else{
      this.router.navigate([APP_ROUTES.VERTICAL_LIST]);
    }
  }
  
  public save() {  
    this.verticalForm.markAllAsTouched();
    this.logger.info('Vertical Form Value',this.verticalForm.value);
    this.verticalForm.markAllAsTouched();
    let method = (this.id.value) ? 'put' : 'post';
    let message=(this.id.value)?'updated':'saved';
    if(this.verticalForm.valid){
      this.logger.info('Vertical Form Value',this.verticalForm.value);
      this.service[method](Api.VERTICAL, this.verticalForm.value).subscribe(res => {
        this.utilityService.notifier(`Vertical Details ${message} successfully`, 'success');
        this.router.navigate([APP_ROUTES.VERTICAL_LIST]);
      });
    }
    // if(this.verticalForm.valid){
    //   this.isEditedData=true;
    //   if(this.id.value){
    //     this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
    //   }
    //   else {
    //     this.openDailog(Message.SAVE_OPEN_DAILOG);
    //   }  
    // }
  }
  
  saveVertical(){
    this.verticalForm.markAllAsTouched();
    let method = (this.id.value) ? 'put' : 'post';
    let message=(this.id.value)?'updated':'saved';
    if(this.verticalForm.valid){
      this.logger.info('Vertical Form Value',this.verticalForm.value);
      this.service[method](Api.VERTICAL, this.verticalForm.value).subscribe(res => {
        this.utilityService.notifier(`Vertical Details ${message} successfully`, 'success');
        this.router.navigate([APP_ROUTES.VERTICAL_LIST]);
      });
    }
  }
  
  openDeactivateForm(e:MatSlideToggleChange){
    let data={id:this.id.value,message:'Vertical Details',api:Api.DEACTIVATE_VERTICAL,route:APP_ROUTES.VERTICAL_LIST}
    const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })
  }
  
  openReactivateForm(e:MatSlideToggleChange){
    let data={id:this.id.value,message:'Vertical Details',api:Api.REACTIVATE_VERTICAL,route:APP_ROUTES.VERTICAL_LIST}
    const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })
  }

  private getVerticalById(){
    this.service.get(Api.VERTICAL+"/"+this.id.value).subscribe(res => {
      this.logger.info('Vertical By Id res',res);
      this.verticalForm.patchValue({...res,
        alias: res.aliases || []
      });
      this.status=this.getStatus(res);
      res.aliases?.forEach(alias => {
        this.aliases.push(this.utilityService.getAliasForm(alias.id,alias.name));
      });
      if(res.submittedForApproval || res.status==='DEACTIVATED'){
        this.verticalForm.disable();
        this.disableSubmit=true;
      }
    });
  }

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivateDtls?.deactivationWefDate,
        reactivationWefDate: data.reactivateDtls?.reactivationWefDate});
    }
  }

  public getAllPermissions(){
    let permissionCodes=[PermissionKey.VERTICAL_MODULE_REACTIVATE_PERMISSION,PermissionKey.VERTICAL_MODULE_DEACTIVATE_PERMISSION,PermissionKey.VERTICAL_MODULE_EDIT_PERMISSION,
                        PermissionKey.VERTICAL_MODULE_ADD_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.VERTICAL_MODULE);
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VERTICAL_MODULE_REACTIVATE_PERMISSION})?.show?true:false;
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VERTICAL_MODULE_DEACTIVATE_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VERTICAL_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VERTICAL_MODULE_ADD_PERMISSION})?.show?true:false;
  }

  get aliases(){return ( <FormArray>this.verticalForm.get('aliases')); }
  get name(){return this.verticalForm.get('name'); }
  get code(){return this.verticalForm.get('code'); }
  get id(){return this.verticalForm.get('id'); }
}
